'use strict';

export class init {
    constructor(opt) {
        this.opt = opt;
        this.bindHandlers();
    }

    bindHandlers() {
        let _self = this;
        init.setCookie(_self.opt.cookieName, _self.opt.cookieValue);
    }

    static setCookie(name, value) {
        document.cookie = name + "=" + value + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/;";
    }
}